/* eslint-disable formatjs/enforce-id */
import { useState, KeyboardEvent, Fragment } from 'react'
import { defineMessage, FormattedMessage, useIntl } from 'react-intl'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'
import {
    CityBreakFoldableInfoContent,
    CityBreakFoldableInfoDropdown,
    CityBreakFoldableInfoItem,
    CityBreakFoldableInfoWrapper,
} from './CityBreakFoldableInfo.styles'
import Box from 'components/shared/Box'
import List from 'components/shared/List'

export const CityBreakFoldableInfo = () => {
    const { formatMessage } = useIntl()
    const [isExtended, setIsExtended] = useState(false)

    const copyData = [
        {
            main: defineMessage({
                id: 'promo.accommodation.city_break_title',
                defaultMessage: '_',
            }),
            details: [
                defineMessage({
                    id: 'promo.accommodation.city_break_detail_1',
                    defaultMessage: '_',
                }),
                defineMessage({
                    id: 'promo.accommodation.city_break_detail_2',
                    defaultMessage: '_',
                }),
                defineMessage({
                    id: 'promo.accommodation.city_break_detail_3',
                    defaultMessage: '_',
                }),
                defineMessage({
                    id: 'promo.accommodation.city_break_detail_4',
                    defaultMessage: '_',
                }),
            ],
        },
        {
            main: defineMessage({
                id: 'promo.accommodation.actual_promotions_combined_title',
                defaultMessage: '_',
            }),
            details: [
                defineMessage({
                    id: 'promo.accommodation.actual_promotions_combined_detail_1',
                    defaultMessage: '_',
                }),
                defineMessage({
                    id: 'promo.accommodation.actual_promotions_combined_detail_2',
                    defaultMessage: '_',
                }),
            ],
        },
    ]

    const PromotionsInfo = (
        <Box direction="column" mt={20} isFullWidth>
            {copyData.map((info, index) => {
                const { main, details } = info

                return (
                    <CityBreakFoldableInfoItem gap={4} isFullWidth key={index}>
                        <Box direction="row" gap={8}>
                            <Icon variant="promotion-discount" />
                            <Text variant="body14Strong" color="grayscale_900">
                                {formatMessage(main, {
                                    strong: (chunks: string[]) => (
                                        <Text
                                            as="span"
                                            variant="body14Strong"
                                            color="primary_500"
                                        >
                                            {chunks}
                                        </Text>
                                    ),
                                })}
                            </Text>
                        </Box>
                        <Box ml={28}>
                            <List variant="body14" color="grayscale_800">
                                {details.map((detail, index) => (
                                    <Fragment key={index}>
                                        {formatMessage(detail)}
                                    </Fragment>
                                ))}
                            </List>
                        </Box>
                    </CityBreakFoldableInfoItem>
                )
            })}
        </Box>
    )

    const handleToggleExtended = () =>
        setIsExtended((isExtended) => !isExtended)

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) =>
        event.key === 'Enter' && handleToggleExtended()

    return (
        <CityBreakFoldableInfoWrapper isFullWidth>
            <CityBreakFoldableInfoDropdown
                direction="row"
                justify="space-between"
                align="center"
                gap={16}
                isFullWidth
                onClick={handleToggleExtended}
                onKeyDown={handleKeyDown}
                data-testid={`promotions-foldable-info-trigger-${
                    isExtended ? 'hide' : 'show'
                }`}
                tabIndex={0}
            >
                <Box direction="column" gap={4}>
                    <Text variant="bodyLargeStrong" color="success">
                        <FormattedMessage
                            id="promo.accommodation.actual_promotions_title"
                            defaultMessage="_"
                        />
                    </Text>
                    <Text variant="bodySmall" color="grayscale_900">
                        <FormattedMessage
                            id="promo.accommodation.actual_promotions_description"
                            defaultMessage="_"
                        />
                    </Text>
                </Box>
                <Icon
                    variant="chevron"
                    color="grayscale_900"
                    rotation={isExtended ? 180 : 0}
                />
            </CityBreakFoldableInfoDropdown>
            <CityBreakFoldableInfoContent
                isOpened={isExtended}
                gap={16}
                isFullWidth
            >
                {PromotionsInfo}
            </CityBreakFoldableInfoContent>
        </CityBreakFoldableInfoWrapper>
    )
}
